import { render, staticRenderFns } from "./page-header.vue?vue&type=template&id=4f34284e&scoped=true"
import script from "./page-header.vue?vue&type=script&lang=js"
export * from "./page-header.vue?vue&type=script&lang=js"
import style0 from "./page-header.vue?vue&type=style&index=0&id=4f34284e&prod&scoped=true&lang=scss"
import style1 from "./page-header.vue?vue&type=style&index=1&id=4f34284e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f34284e",
  null
  
)

export default component.exports